import React from 'react';
import { styled } from 'styled-components';

const ImageUI = ({
   src,
   alt,
   width,
   height,
}: {
   src: string;
   alt: string;
   width?: string;
   height?: string;
}) => {
   return (
      <ImageWrapper $width={width} $height={height}>
         <Image src={src} alt={alt} />
      </ImageWrapper>
   );
};

const ImageWrapper = styled.div<{ $width?: string; $height?: string }>`
   width: ${({ $width }) => $width};
   height: ${({ $height }) => $height};
`;

const Image = styled.img`
   width: 100%;
`;

export default ImageUI;
